import { steps } from '../data/landingPageData';
import Icon from './Icon';
import './HowItWorks.css';

function HowItWorks() {
  return (
    <section className="steps-section" id="how-it-works">
      <h2>How it works</h2>
      <div className="steps">
        {steps.map((step, index) => (
          <article className="step" key={step.number}>
            <div className="step-icon">
              <Icon name={step.icon} />
            </div>
            <div>
              <span>{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
            {index < steps.length - 1 ? <i aria-hidden="true" /> : null}
          </article>
        ))}
      </div>
    </section>
  );
}

export default HowItWorks;
